<template>
  <div class="home">
    <p class="tips">店铺名以小程序中的为准，如下面没有你要下单的店铺，请点击选择地点搜索附近地点</p>

<!--    第一版本的模糊搜索获取店铺-->
<!--    <div class="search">-->
<!--      <el-input v-model="city.title" class="search-ipt" placeholder="请点击选择地点" disabled></el-input>-->
<!--      <el-button type="primary" @click="getCity" style="margin-left: 20px;background-color: #006DE7;border-color:#006DE7;">选择地点</el-button>-->
<!--    </div>-->

    <div class="search">
      <el-input v-model="city.cityName" class="search-ipt" placeholder="请点击选择城市" disabled></el-input>
      <el-button type="primary" @click="getSearchCity" style="margin-left: 20px;background-color: #006DE7;border-color:#006DE7;">选择市级城市</el-button>
    </div>

    <div class="search" style="margin-top: 20px">
      <el-input v-model="keyword" class="search-ipt" placeholder="请输入店铺名"  @input="handleInput"></el-input>
      <el-button type="primary" @click="getShopListBySearch" style="background-color: #006DE7;border-color:#006DE7;">搜索</el-button>
    </div>

    <!--    附近门店-->
    <div>
      <p>附近门店</p>
      <div v-if="shopList.length===0 && !requestFlag" class="noShop">暂无符合门店</div>
      <div v-if="requestFlag" class="noShop">搜索中，请稍等</div>
      <div v-else>
        <div v-for="item in shopList" :key="item.shopId" @click="changeShop(item)">
          <div :class="[item.status !==1 || !isInBusinessHours(item.openingHours) ? 'deActive':'','shopItem']">
            <p :class="[item.status !==1 || !isInBusinessHours(item.openingHours) ? 'deActive':'shopName']">{{ item.name }}</p>

            <p class="shopAdd" style="margin-top: 13px;margin-bottom: 4px">{{item.address }}</p>

            <p class="shopAdd">营业时间：{{ item.openingHours[0].startTime +"-"+ item.openingHours[0].endTime}}<span v-if="item.openingHours[1]">；{{item.openingHours[1].startTime +"-"+ item.openingHours[1].endTime}}</span></p>


            <div v-if="item.status === 1 && isInBusinessHours(item.openingHours) && item.supportOrderTypes && item.supportOrderTypes !=='1' " class="tag"><p>{{item.statusName}}</p></div>
<!--            <div v-else-if="item.supportOrderTypes == 1 || !item.supportOrderTypes" style="color: #989898" class="tag"><p>{{item.statusName}}</p></div>-->
<!--            <div v-else-if="!isInBusinessHours(item.openingHours)" style="color: #989898" class="tag"><p>{{item.statusName}}</p></div>-->
            <div v-else class="tag deActive"><p>{{item.statusName}}</p></div>


          </div>
        </div>
      </div>


    </div>

    <!-- 添加订单提示弹窗 -->
    <el-dialog
      title="订单提示"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
    >
      <span>已下单，是否查看？一个下单链接只能下一杯哦~</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goToOrder">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { findNear, queryCard,searchShops} from "../api/cbd.js"


export default {
  name: "Location",
  data() {
    return {
      cardID: '',
      location: {
        latitude: '',
        longitude: ''
      },
      city:{},
      keyword:'',
      //cityName: '',
      //cityMdCode: '',
      //cityList: [],
      shopName: '',
      shopList: [],
      requestFlag:false,
      dialogVisible: false  // 添加弹窗控制变量
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.query.cardID){
          this.cardID = this.$route.query.cardID
          localStorage.setItem('cardID', this.cardID);
        }
      },
      deep:true
    }
  },
  mounted() {
    //console.log(this.$route.query.cardID,'this.$route.query.cardID')
    //var that = this
    if (this.$route.query.cardID) {
      this.cardID = this.$route.query.cardID
      localStorage.setItem('cardID', this.cardID);
    }
    if (this.$route.query.type) {
      //this.type = this.$route.query.type || ""
      const type = this.$route.query.type || ""
      localStorage.setItem('type', type);
    }

    if(JSON.parse(localStorage.getItem('city'))) this.city = JSON.parse(localStorage.getItem('city'))

    // bus.$on('changeCity', data=>{
    //   that.city = JSON.parse(JSON.stringify(data))
    //   // that.cityName = data.cityName
    //   // that.cityMdCode = data.cityMdCode
    //   console.log(that.city,'6666that.cityName')
    //   //that.$forceUpdate();
    // })

    this.AD();
    //CBD({cardID:localStorage.getItem('cardID')})
    //this.getLocation();
    //this.getShopListByLocation()
  },
  methods: {
    //获取经纬度
    getLocation() {
      // 如果city中有location数据，直接使用
      // if (this.city.location && this.city.location.lat && this.city.location.lng) {
      //   this.getShopListByLocation();
      //   return;
      // }
      if (this.city && this.city.cityMdCode){
        this.getShopListBySearch()
        return;
      }

      // 检查浏览器是否支持地理定位
      if (!navigator.geolocation) {
        this.$message.error('请选择地点');
        return;
      }

      // 设置超时处理
      // const timeoutId = setTimeout(() => {
      //   this.$message.error('请选择地点');
      // }, 5000); // 5秒超时

      navigator.geolocation.getCurrentPosition(
        (position) => {
          //clearTimeout(timeoutId);
          const lat = String(
            Number(parseFloat(`${position.coords.latitude}`))
          );
          const lng = String(
            Number(parseFloat(`${position.coords.longitude}`))
          );
          this.location.latitude = lat;
          this.location.longitude = lng;
          this.getShopListByLocation();
        },
        (error) => {
          //clearTimeout(timeoutId);
          console.error('定位错误:', error.message);
          this.$message.error('获取定位出错，请选择地点');
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }
      );
    },
    // 判断店铺是否在营业时间内
    isInBusinessHours(openingHours) {
      if (!openingHours || !openingHours[0]) return false;
      
      const now = new Date();
      const currentTime = now.getHours().toString().padStart(2, '0') + ':' + 
                         now.getMinutes().toString().padStart(2, '0') + ':' + 
                         now.getSeconds().toString().padStart(2, '0');
      
      const startTime = openingHours[0].startTime;
      const endTime = openingHours[0].endTime;

      let flag = currentTime >= startTime && currentTime <= endTime || false
      if (openingHours.length > 1 && !flag){
        const startTimeTwo = openingHours[1].startTime;
        const endTimeTwo = openingHours[1].endTime;
        flag = currentTime >= startTimeTwo && currentTime <= endTimeTwo;
      }

      return flag;
    },
    //查询卡密
    AD() {
      if (!localStorage.getItem('cardID')) return this.$message.error('未复制完整卡密链接')
      let params = {
        cardID: localStorage.getItem('cardID'),
        type:localStorage.getItem('type') || ""
      }
      queryCard(params).then(res => {
        localStorage.setItem('value', JSON.stringify(res));
        if (res.msg != 'TOKEN已过期!') this.getLocation();
        if (res.code == 0 && res.msg =="已下单") {
          this.dialogVisible = true;  // 显示弹窗而不是直接跳转
        }
      })
    },
    //模糊搜索
    getCity() {
      this.$router.push('city')
    },
    //获取市级城市列表
    getSearchCity() {
      this.$router.push('searchCity')
    },
    //选择市级城市
    // changeCity(city) {
    //   console.log(city,'++++')
    // },
    //城市+关键词搜索店铺列表
    // searchShop() {
    //   if (!this.city.cityMdCode) return this.$message.error('请先选择城市')
    //   let params = {
    //     CityMdCode: this.city.cityMdCode,
    //     shopMdName: this.shopName
    //   }
    //   queryShopsByName(params).then(res => {
    //     //console.log(res, '城市+关键词搜索店铺列表返回')
    //     let data = res.data
    //     this.shopList = data
    //   })
    // },
    changeShop(item) {
      //选择店铺
      if (item.status !== 1) return this.$message.error(`${item.statusName}，暂不可选`);
      
      const isOpen = this.isInBusinessHours(item.openingHours);
      if (!isOpen) {
        return this.$message.error('当前不在营业时间内，暂不可选');
      }

      if (!item.supportOrderTypes || item.supportOrderTypes == '1'){
        return this.$message.error('暂未开启线上点单');
      }
      
      let info = {
        shopName:item.name,
        shopID:item.shopId,
        address:item.address,
        shopPhone:item.shopPhone,
        shopLongitude:item.longitudeGd,
        shopLatitude:item.latitudeGd
      }
      localStorage.setItem('shopInfo', JSON.stringify(info));
      this.$router.push('/shop')
    },
    getShopListByLocation() {
      this.requestFlag = true;
      let params = {
        latitude: this.location.latitude,
        longitude: this.location.longitude
      };

      // 优先使用city中的位置信息
      // if (this.city.location && this.city.location.lat && this.city.location.lng) {
      //   params.latitude = this.city.location.lat;
      //   params.longitude = this.city.location.lng;
      // }
      if (this.city && this.city.cityMdCode){
        this.getShopListBySearch()
        return;
      }

      // 检查是否有有效的位置信息
      if (!params.latitude || !params.longitude) {
        this.requestFlag = false;
        this.$message.error('请选择地点');
        return;
      }

      // 确保数值类型
      params.latitude = Number(parseFloat(params.latitude));
      params.longitude = Number(parseFloat(params.longitude));

      findNear(params).then(res => {
        console.log(res, '根据经纬度查询店铺返回');
        let data = res.data;
        // 处理每个店铺的营业状态，但保留原有status
        data = data.map(shop => {
          const isOpen = this.isInBusinessHours(shop.openingHours);
          let statusName = shop.status === 1 ? (isOpen ? '营业中' : '休息中') : shop.statusName
          if (shop.supportOrderTypes==1){
            statusName = '只支持外卖'
          }else if(!shop.supportOrderTypes){
            statusName = '暂停线上点单'
          }
          return {
            ...shop,
            statusName
          };
        });
        this.shopList = data;
        this.requestFlag = false;
      }).catch(err => {
        this.requestFlag = false;
        //this.$message.error('获取店铺列表失败，请重试');
      });
    },


    getShopListBySearch() {
      this.requestFlag = true;

      // 检查是否有有效的位置信息
      if (!this.city.cityMdCode) {
        this.requestFlag = false;
        this.$message.error('请选择城市');
        return;
      }

      let params = {
        cityId: this.city.cityMdCode,
        keyword: this.keyword
      };

      searchShops(params).then(res => {
        console.log(res, '根据经纬度查询店铺返回');
        let data = res.data;
        // 处理每个店铺的营业状态，但保留原有status
        data = data.map(shop => {
          const isOpen = this.isInBusinessHours(shop.openingHours);
          let statusName = shop.status === 1 ? (isOpen ? '营业中' : '休息中') : shop.statusName
          if (shop.supportOrderTypes==1){
            statusName = '只支持外卖'
          }else if(!shop.supportOrderTypes){
            statusName = '暂停线上点单'
          }
          return {
            ...shop,
            statusName
          };
        });
        this.shopList = data;
        this.requestFlag = false;
      }).catch(err => {
        this.requestFlag = false;
        //this.$message.error('获取店铺列表失败，请重试');
      });
    },

    handleInput(val){
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if(val !== ''){
          this.getShopListBySearch();
        }
      }, 1000)
    },

    // 跳转到订单页面
    goToOrder() {
      this.dialogVisible = false;
      this.$router.push('/order');
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  padding: 15px;
  margin-bottom: 60px;
  .search {
    width: 100%;
    margin: 0 auto 20px auto;
    display: flex;
    align-items: center;
    .search-ipt {
      margin-right: 20px;
    }
  }

  .choseDrink {
    width: 100%;
    margin: 20px auto 0 auto;
  }

  .noShop{
    margin: 20px auto;
    text-align: center;
    color: #006DE7;
  }

  .shopItem {
    //min-height: 130px;
    border: 1px solid #F6E9EB;
    border-radius: 15px;
    padding: 13px;
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    //justify-content: space-around;
    color: #636363;
    .shopName{
      color: #1a1a1a;
      font-size: 17px;
      font-weight: 600;
    }

    .shopAdd {
      color: #8c8c8c;
      font-size: 13px;
      -webkit-line-clamp: 1;
      text-overflow: ellipsis;
      word-break: break-all;

      //margin: 8px 0;
      //color: #636363;
    }
  }
}

.tag{
  //min-width: 60px;
  //max-width: 80px;
  //height: 20px;
  //margin: 5px 0;
  //display: flex;
  //justify-content: center;
  //align-items: center;
  //padding: 5px 5px;
  //font-size: 14px;
  //background-color: #F5F5F5;
  //color: #989898;
  //border-radius: 5px;

  //display: inline-block;
  width: fit-content;
  border: 1px solid rgba(94,178,9,.4);
  //-webkit-align-items: center;
  align-items: center;
  border-radius: 4px;
  //display: -webkit-flex;
  display: flex;
  height: 20px;
  //-webkit-justify-content: center;
  justify-content: center;
  line-height: 20px;
  text-align: center;
  //margin-right: 8px;
  padding: 0 4px;
  box-sizing: border-box;

  color: #5eb209;
  font-size: 12px;
  margin-top: 7px;
}

.active{
  background-color: #006DE7;
  color: #FFFFFF;
}

.deActive{
  color: rgb(152, 152, 152) !important;
  border-color: rgb(152, 152, 152);
}

.tips{
  font-size: 15px;
  padding: 10px 0;
  //color: #999999;
  color: red;
  //display: flex;
  //flex-direction: column;
  //align-items: center;
}

/deep/ .el-dialog {
  margin-top: 30vh !important;
}
</style>